
    export default {
      path: `/home/runner/work/fase2-website/fase2-website/src/components/shared/contact-form.kpa`,
      template: `<section class="contact-form flex-column">
        <div id="kontakt" class="anchor"></div>
        <div class="wrapper">
            <hex-headline left text="Wir sind für Sie da!"></hex-headline>

            <p>
                Ob Grünpflege, Graupflege oder Hausmeisterservice - teilen Sie uns Ihre Wünsche mit. Wir finden die passende Lösung für Sie. 
                Kontaktieren Sie uns noch heute!
            </p>

            <div class="contact-wrapper">
                <form id="contactForm" class="" novalidate method="post" enctype="multipart/form-data">
                    <!-- Ihr Name, Nachname* -->
                    <label for="fullname" class="form-group">
                        <span class="error-message" data-error-for="fullname"></span>
                        <input type="text" id="fullname" name="fullname" placeholder=" " required />
                        <span class="label">Ihr Name, Nachname*</span>
                    </label>

                    <!-- Ihre Firmenbezeichnung -->
                    <label for="company" class="form-group">
                        <span class="error-message" data-error-for="company"></span>
                        <input type="text" id="company" name="company" placeholder=" " />
                        <span class="label">Ihre Firmenbezeichnung</span>
                    </label>

                    <!-- Ihre E-Mail Adresse* -->
                    <label for="email" class="form-group">
                        <span class="error-message" data-error-for="email"></span>
                        <input type="email" id="email" name="email" placeholder=" " required />
                        <span class="label">Ihre E-Mail Adresse*</span>
                    </label>

                    <!-- Ihre Telefonnummer* -->
                    <label for="phone" class="form-group">
                        <span class="error-message" data-error-for="phone"></span>
                        <input type="tel" id="phone" name="phone" placeholder=" " required />
                        <span class="label">Ihre Telefonnummer*</span>
                    </label>

                    <!-- Ihre Rechnungsadresse -->
                    <label for="billingaddress" class="form-group">
                        <span class="error-message" data-error-for="billingaddress"></span>
                        <input type="text" id="billingaddress" name="billingaddress" placeholder=" " />
                        <span class="label">Ihre Rechnungsadresse</span>
                    </label>

                    <!-- Ihre Objektadresse -->
                    <label for="objectaddress" class="form-group">
                        <span class="error-message" data-error-for="objectaddress"></span>
                        <input type="text" id="objectaddress" name="objectaddress" placeholder=" " />
                        <span class="label">Ihre Objektadresse</span>
                    </label>
                    
                    <!-- Dienstleistungsart -->
                    <!-- <label for="service" class="form-group">
                        <span class="error-message" data-error-for="service"></span>
                        <div class="custom-select-wrapper">
                            <div class="custom-select" name="service" tabindex="0">
                                <div class="custom-select-trigger">
                                    <span>Dienstleistungsart</span>
                                    <div class="arrow"></div>
                                </div>
                                <div class="custom-options">
                                    <div class="custom-option" data-value="gruenpflege">Grünpflege</div>
                                    <div class="custom-option" data-value="graupflege">Graupflege</div>
                                    <div class="custom-option" data-value="hausmeisterdienst">Hausmeisterdienst</div>
                                    <div class="custom-option" data-value="reinigungsdienst">Reinigungsdienst</div>
                                </div>
                            </div>
                            <input type="hidden" name="service" id="service" required />
                        </div>
                    </label> -->

                    <!-- Message -->
                    <label for="message" class="form-group">
                        <span class="error-message" data-error-for="message"></span>
                        <textarea id="message" name="message" placeholder=" " required></textarea>
                        <span class="label">Nachricht*</span>
                    </label>

                    <!-- Attachment -->
                    <div class="form-group attachment label">
                        <span class="error-message" data-error-for="attachment"></span>
                        <input type="file" id="attachment" name="attachment" accept=".jpg,.jpeg,.png,.pdf,.docx" multiple />
                        <!--<span class="label box-shadow">Dateianhang hinzufügen</span>-->
                        <div>
                            <div id="fileList" class="file-list"></div>
                            <span>
                                <span class="label box-shadow button">Dateianhang hinzufügen</span>
                                <span class="filelist-delete box-shadow">Dateianhang entfernen</span>
                            </span>
                        </div>
                    </div>

                    <!-- Approval -->
                    <div class="form-group">
                        <span class="error-message" data-error-for="approval"></span>
                        <input type="checkbox" id="approval" name="approval" required />
                        <label for="approval">
                            <span class="checkbox-label">
                                Hiermit bestätige ich, dass ich die 
                                <a href="/agbs">AGB's</a> 
                                und die <a href="/datenschutzerklaerung">Datenschutzerklärung</a> 
                                sorgfältig zur kenntniss genommen habe und mit diesen einverstanden bin.
                            </span>
                            <i class="fa fa-check"></i>
                        </label>
                    </div>
                    
                    <!-- Submit Button -->
                    <div class="form-group">
                        <button type="submit" class="btn btn-submit box-shadow">Senden</button>
                    </div>

                    <div class="response-message" style="display: none;"></div>
                </form>

                <div class="contact-image box-shadow">
                    <img src="/images/junge.jpg" alt="FASE2 Finger Junge"/>
                </div>
            </div>
        </div>
    </section>`,
      style: `@charset "UTF-8";
contact-form .contact-form {
  position: relative;
  margin: 0;
  padding: 0;
  background-color: #f2f2f1;
  margin-top: 96px;
}
contact-form .contact-form .wrapper {
  padding: 0;
}
contact-form .contact-form .wrapper .contact-wrapper {
  padding: 0;
  display: flex;
  flex-flow: column nowrap;
  justify-content: center;
  align-items: center;
  gap: 32px;
}
contact-form .contact-form .wrapper .contact-wrapper form {
  display: flex;
  flex-flow: column nowrap;
  justify-content: center;
  align-items: stretch;
}
contact-form .contact-form .wrapper .contact-wrapper form .form-group {
  display: flex;
  flex-flow: column nowrap;
  justify-content: center;
  align-items: stretch;
  flex-direction: column-reverse;
  /* Aktivierter Zustand */
}
contact-form .contact-form .wrapper .contact-wrapper form .form-group span {
  position: relative;
  height: 30px;
}
contact-form .contact-form .wrapper .contact-wrapper form .form-group span.label {
  width: calc(100% - 16px);
  color: #2c4143;
  transform: translate(8px, 30px);
  transition: transform 0.2s linear 0s, font-size 0.2s linear 0s;
}
contact-form .contact-form .wrapper .contact-wrapper form .form-group input {
  outline: none;
  border-color: #2c4143;
  border-style: solid;
  border-radius: 0;
  border-width: 0 0 2px 0;
  padding: 3px 8px;
  transition: border-color 0.2s ease;
  background-color: transparent;
}
contact-form .contact-form .wrapper .contact-wrapper form .form-group input:hover {
  border-color: #64c16c;
}
contact-form .contact-form .wrapper .contact-wrapper form .form-group textarea {
  height: 33px;
  outline: none;
  border-color: #2c4143;
  border-style: solid;
  border-radius: 0;
  border-width: 0 0 2px 0;
  padding: 3px 8px;
  transition: border-color 0.2s ease;
  font-size: 16px;
  line-height: 1.6;
  background-color: transparent;
  resize: none;
  overflow: hidden;
}
contact-form .contact-form .wrapper .contact-wrapper form .form-group textarea:hover {
  border-color: #64c16c;
}
contact-form .contact-form .wrapper .contact-wrapper form .form-group input + span.label,
contact-form .contact-form .wrapper .contact-wrapper form .form-group textarea + span.label {
  cursor: text;
}
contact-form .contact-form .wrapper .contact-wrapper form .form-group textarea:focus {
  border-color: #64c16c;
}
contact-form .contact-form .wrapper .contact-wrapper form .form-group:has(button) {
  margin: 30px 0 0 0;
}
contact-form .contact-form .wrapper .contact-wrapper form .form-group input:focus {
  border-color: #64c16c;
}
contact-form .contact-form .wrapper .contact-wrapper form .form-group input:focus + span.label {
  font-size: 12px;
  transform: translate(8px, 12px);
}
contact-form .contact-form .wrapper .contact-wrapper form .form-group .error-message {
  font-size: 12px;
  color: red;
  line-height: 1.6;
  text-align: right;
}
contact-form .contact-form .wrapper .contact-wrapper form .form-group .error-message:not(:empty) ~ span.label {
  color: red;
}
contact-form .contact-form .wrapper .contact-wrapper form .form-group .error-message:not(:empty) ~ input {
  border-color: red;
  background-color: #ffe6e6;
}
contact-form .contact-form .wrapper .contact-wrapper form .form-group .error-message:not(:empty) ~ textarea {
  border-color: red;
  background-color: #ffe6e6;
}
contact-form .contact-form .wrapper .contact-wrapper form .form-group .has-value + span.label {
  font-size: 12px;
  transform: translate(8px, 12px);
}
contact-form .contact-form .wrapper .contact-wrapper form .form-group input[type=checkbox] {
  z-index: 2;
}
contact-form .contact-form .wrapper .contact-wrapper form .form-group input[type=checkbox] {
  display: none; /* Versteckt die ursprüngliche Checkbox */
}
contact-form .contact-form .wrapper .contact-wrapper form .form-group input[type=file] {
  display: none; /* Versteckt das Standard-Datei-Input */
}
contact-form .contact-form .wrapper .contact-wrapper form .form-group label {
  display: flex;
  flex-flow: row nowrap;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  position: relative;
  font-size: 16px;
}
contact-form .contact-form .wrapper .contact-wrapper form .form-group label span {
  height: auto;
}
contact-form .contact-form .wrapper .contact-wrapper form .form-group label i {
  display: inline-block;
  min-width: 24px;
  min-height: 24px;
  width: 24px;
  height: 24px;
  border: 2px solid #2c4143;
  margin-right: 8px;
  text-align: center;
  line-height: 20px;
  font-size: 20px;
  color: transparent;
  transition: all 0.2s ease-in-out;
  transition: border-color 0.2s ease;
}
contact-form .contact-form .wrapper .contact-wrapper form .form-group label i:hover {
  border-color: #64c16c;
}
contact-form .contact-form .wrapper .contact-wrapper form .form-group label .checkbox-label {
  flex-grow: 1;
  padding: 0 16px 0 0;
}
contact-form .contact-form .wrapper .contact-wrapper form .form-group label:hover i {
  border-color: #64c16c;
}
contact-form .contact-form .wrapper .contact-wrapper form .form-group .error-message:not(:empty) ~ label i {
  border-color: red;
  background-color: #ffe6e6;
}
contact-form .contact-form .wrapper .contact-wrapper form .form-group input[type=checkbox]:checked + label i {
  background-color: #64c16c;
  border-color: #64c16c;
  color: #fff; /* Zeigt den Haken in weiß */
}
contact-form .contact-form .wrapper .contact-wrapper form .form-group .custom-select-wrapper {
  position: relative;
}
contact-form .contact-form .wrapper .contact-wrapper form .form-group .custom-select {
  position: relative;
  color: #2c4143;
  cursor: pointer;
  outline: 0;
}
contact-form .contact-form .wrapper .contact-wrapper form .form-group .custom-select:focus .custom-select-trigger {
  border-color: #64c16c;
}
contact-form .contact-form .wrapper .contact-wrapper form .form-group .custom-select-trigger {
  position: relative;
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 30px 0 0 0;
  padding: 0 8px 0 8px;
  border-color: #2c4143;
  border-style: solid;
  border-radius: 0;
  border-width: 0 0 2px 0;
  background-color: transparent;
  transition: border-color 0.2s ease;
}
contact-form .contact-form .wrapper .contact-wrapper form .form-group .custom-select-trigger:hover {
  border-color: #64c16c;
}
contact-form .contact-form .wrapper .contact-wrapper form .form-group .custom-select-trigger span {
  height: 28px;
}
contact-form .contact-form .wrapper .contact-wrapper form .form-group .custom-select-trigger::before {
  content: "";
  position: absolute;
  top: -30px;
  left: 0;
  width: 100%;
  height: 30px;
}
contact-form .contact-form .wrapper .contact-wrapper form .form-group .custom-select-trigger::after {
  content: "";
  position: absolute;
  top: 100%;
  left: 0;
  width: 100%;
  height: 30px;
}
contact-form .contact-form .wrapper .contact-wrapper form .form-group .arrow {
  width: 0;
  height: 0;
  border-left: 6px solid transparent;
  border-right: 6px solid transparent;
  border-top: 6px solid #2c4143;
  transition: transform 0.2s ease;
  margin-right: 5px;
}
contact-form .contact-form .wrapper .contact-wrapper form .form-group .custom-select.open .arrow {
  transform: rotate(180deg);
}
contact-form .contact-form .wrapper .contact-wrapper form .form-group .custom-options {
  position: absolute;
  top: calc(100% - 2px);
  left: 0;
  right: 0;
  background: #fff;
  border-color: #64c16c;
  border-style: solid;
  border-radius: 0;
  border-width: 2px 0 0 0;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.5);
  max-height: 200px;
  overflow-y: auto;
  z-index: 10;
  display: none;
}
contact-form .contact-form .wrapper .contact-wrapper form .form-group .custom-select.open .custom-options {
  display: block;
}
contact-form .contact-form .wrapper .contact-wrapper form .form-group .custom-option {
  padding: 6px 24px;
  cursor: pointer;
  transition: background-color 0.2s ease;
}
contact-form .contact-form .wrapper .contact-wrapper form .form-group .custom-option:hover {
  background-color: #f5f5f5;
}
contact-form .contact-form .wrapper .contact-wrapper form .form-group .custom-option.selected {
  background-color: #64c16c;
  color: #fff;
}
contact-form .contact-form .wrapper .contact-wrapper form .form-group .error-message:not(:empty) ~ .custom-select-wrapper .custom-select .custom-select-trigger {
  border-color: red;
  background-color: #ffe6e6;
}
contact-form .contact-form .wrapper .contact-wrapper form .form-group .error-message:not(:empty) ~ .custom-select-wrapper .custom-select .custom-select-trigger span {
  color: red;
}
contact-form .contact-form .wrapper .contact-wrapper form .form-group .error-message:not(:empty) ~ .custom-select-wrapper .custom-select .custom-select-trigger .arrow {
  border-top-color: red;
}
contact-form .contact-form .wrapper .contact-wrapper form .form-group:focus-within input:focus + span.label,
contact-form .contact-form .wrapper .contact-wrapper form .form-group:focus-within textarea:focus + span.label {
  font-size: 12px;
  transform: translate(8px, 12px);
}
contact-form .contact-form .wrapper .contact-wrapper form div.form-group.attachment.label span.label {
  height: auto;
  transform: translate(0, 0);
  width: 220px;
  text-align: center;
  font-family: "Lato", sans-serif;
  font-size: 16px;
  font-weight: 400;
  color: #fff;
  padding: 10px 20px;
  border: none;
  border-radius: 8px;
  line-height: 1.15;
  cursor: pointer;
  background-color: var(--accent-color);
  transition: background-color 0.3s ease;
}
contact-form .contact-form .wrapper .contact-wrapper form div.form-group.attachment.label span.label:hover {
  background-color: var(--hover-color);
}
contact-form .contact-form .wrapper .contact-wrapper form div.form-group.attachment.label span.label.button {
  font-family: "Lato", sans-serif;
  font-size: 16px;
  line-height: 0.9;
  height: 44px;
  font-weight: 400;
  color: #fff;
  padding: 10px 20px;
  border: 3px solid #ffffff;
  border-radius: 30px;
  cursor: pointer;
  background-color: var(--primary-color);
  transition: background-color 0.3s ease;
}
contact-form .contact-form .wrapper .contact-wrapper form div.form-group.attachment.label span.label.button:hover {
  background-color: var(--accent-color);
}
contact-form .contact-form .wrapper .contact-wrapper form div.form-group.attachment.label div {
  padding: 30px 0;
  position: relative;
}
contact-form .contact-form .wrapper .contact-wrapper form div.form-group.attachment.label div.file-list {
  padding: 0;
  display: flex;
  flex-flow: row wrap;
  justify-content: flex-start;
  align-items: flex-start;
  margin-bottom: 1rem;
  cursor: default;
}
contact-form .contact-form .wrapper .contact-wrapper form div.form-group.attachment.label div.file-list:empty {
  display: none;
}
contact-form .contact-form .wrapper .contact-wrapper form div.form-group.attachment.label div > span {
  display: flex;
  flex-flow: row wrap;
  justify-content: flex-start;
  align-items: center;
  gap: 24px;
  height: auto;
}
contact-form .contact-form .wrapper .contact-wrapper form div.form-group.attachment.label .file-list-item {
  padding: 8px;
  border: 1px solid #2c4143;
  border-radius: 8px;
  margin-bottom: 8px;
  -webkit-user-select: none;
     -moz-user-select: none;
          user-select: none;
  box-shadow: rgba(50, 50, 93, 0.25) 0px 2px 5px -1px, rgba(0, 0, 0, 0.3) 0px 1px 3px -1px;
  white-space: nowrap;
}
contact-form .contact-form .wrapper .contact-wrapper form div.form-group.attachment.label span.filelist-delete {
  height: auto;
  line-height: 1.15;
  width: 220px;
  text-align: center;
  font-family: "Lato", sans-serif;
  font-size: 16px;
  font-weight: 400;
  color: #fff;
  padding: 10px 20px;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  background-color: #e77070;
  transition: background-color 0.3s ease;
}
contact-form .contact-form .wrapper .contact-wrapper form div.form-group.attachment.label span.filelist-delete:hover {
  background-color: #cc6363;
}
contact-form .contact-form .wrapper .contact-wrapper form div.form-group.attachment.label div.file-list:empty + span > span.filelist-delete {
  display: none;
}
@media (max-width: 511px) {
  contact-form .contact-form .wrapper .contact-wrapper form div.form-group.attachment.label div > span {
    display: flex;
    flex-flow: column nowrap;
    justify-content: flex-start;
    align-items: flex-start;
  }
}
contact-form .contact-form .wrapper .contact-wrapper form .response-message {
  display: none;
  padding: 16px;
  margin: 16px 0;
  border-radius: 8px;
  font-size: 20px;
  line-height: 1.6;
  text-align: center;
  transition: all 0.3s ease;
  font-weight: 700;
}
contact-form .contact-form .wrapper .contact-wrapper .contact-image {
  position: relative;
  overflow: hidden;
  width: calc(100% + 64px);
  height: 100%;
  margin-top: 64px;
}
contact-form .contact-form .wrapper .contact-wrapper .contact-image img {
  width: 100%;
  height: 105%;
  -o-object-fit: cover;
     object-fit: cover;
  display: block;
}
@media (min-width: 860px) {
  contact-form .contact-form .wrapper .contact-wrapper {
    flex-flow: row nowrap;
    justify-content: center;
    align-items: center;
  }
  contact-form .contact-form .wrapper .contact-wrapper > form + .contact-image {
    min-width: 40%;
    max-width: 50%;
    width: 30%;
    border-radius: 8px;
    align-self: flex-start;
    border-radius: 8px;
    margin-top: 40px;
  }
}
@media (min-width: 993px) {
  contact-form .contact-form .wrapper .contact-wrapper {
    gap: 64px;
  }
}`,
      script: `(async () => { "use strict";
return {
    data: {
        endpoint: 'https://fase2.de/server/contact-form.php',
    },
    methods: {
        validateField(field) {
            const errorMessage = field.closest('.form-group')?.querySelector('.error-message');
            if (field.type === 'checkbox') {
                if (field.required && !field.checked) {
                    errorMessage.textContent = 'Bitte bestätigen Sie dieses Feld.';
                    return false;
                }
                errorMessage.textContent = '';
                return true;
            }
            if (field.type === 'file') {
                const fileInput = field;
                if (fileInput.required && fileInput.files.length === 0) {
                    errorMessage.textContent = 'Bitte fügen Sie eine Datei hinzu.';
                    return false;
                }
                const allowedTypes = ['image/jpeg', 'image/png', 'application/pdf', 'application/msword'];
                for (let file of fileInput.files) {
                    if (file.size > 5 * 1024 * 1024) {
                        errorMessage.textContent = \`Die Datei $-{file.name} ist zu groß. Maximal 5MB erlaubt.\`;
                        return false;
                    }
                    if (!allowedTypes.includes(file.type)) {
                        errorMessage.textContent = \`Die Datei $-{file.name} hat ein ungültiges Format.\`;
                        return false;
                    }
                }
                errorMessage.textContent = '';
                return true;
            }
            if (!field.required && !field.pattern && !field.value.trim()) {
                errorMessage.textContent = '';
                return true;
            }
            if (field.required && !field.value.trim()) {
                errorMessage.textContent = 'Dieses Feld ist erforderlich.';
                return false;
            }
            if (field.pattern) {
                const regex = new RegExp(field.pattern);
                if (!regex.test(field.value)) {
                    errorMessage.textContent = field.title || 'Ungültige Eingabe.';
                    return false;
                }
            }
            errorMessage.textContent = '';
            return true;
        },
        validateForm() {
            const form = document.getElementById('contactForm');
            let isValid = true;
            Array.from(form.elements).forEach((field) => {
                if (field instanceof HTMLInputElement || field instanceof HTMLTextAreaElement) {
                    const valid = this.validateField(field);
                    if (!valid)
                        isValid = false;
                }
            });
            return isValid;
        },
        async submitForm(event) {
            event.preventDefault();
            if (!this.validateForm())
                return;
            const form = event.target;
            const formData = new FormData(form);
            try {
                if (this.endpoint === '#') {
                    console.warn('⚠ Kein gültiger Endpoint gesetzt! Die Daten wurden nicht gesendet.');
                    this.showResponseMessage('error', 'Das Formular wurde nicht gesendet, da kein Zielserver konfiguriert ist.');
                    return;
                }
                const response = await fetch(this.endpoint, {
                    method: 'POST',
                    body: formData,
                });
                if (!response.ok)
                    throw new Error('Fehler beim Senden der Anfrage.');
                const result = await response.json();
                this.showResponseMessage('success', 'Ihre Nachricht wurde erfolgreich gesendet!');
                form.reset();
                form.querySelectorAll('input, textarea').forEach((field) => {
                    field.classList.remove('has-value');
                });
                document.getElementById('fileList').innerHTML = '';
                form.querySelectorAll('.error-message').forEach(el => el.textContent = '');
            }
            catch (error) {
                console.error('Formular Fehler:', error);
                this.showResponseMessage('error', 'Ein Fehler ist aufgetreten. Bitte versuchen Sie es erneut.');
            }
        },
        showResponseMessage(type, message) {
            const responseMessage = document.querySelector('.response-message');
            responseMessage.style.display = 'block';
            responseMessage.textContent = message;
            responseMessage.className = \`response-message $-{type}\`;
        },
        adjustTextareaHeight(textarea) {
            const computedStyle = window.getComputedStyle(textarea);
            const paddingTop = parseInt(computedStyle.paddingTop || '0', 10);
            const paddingBottom = parseInt(computedStyle.paddingBottom || '0', 10);
            const borderTop = parseInt(computedStyle.borderTopWidth || '0', 10);
            const borderBottom = parseInt(computedStyle.borderBottomWidth || '0', 10);
            const lineHeight = parseInt(computedStyle.lineHeight || '16', 10);
            const initialHeight = lineHeight + paddingTop + paddingBottom + borderTop + borderBottom;
            const scrollHeight = textarea.scrollHeight;
            textarea.style.height = \`$-{Math.max(initialHeight, scrollHeight)}px\`;
        },
        customSelectToggl(event) {
            const form = event.target.closest('form');
            form.querySelectorAll('input, textarea').forEach((field) => field.blur());
            const select = event.target.closest('.custom-select');
            select.classList.toggle('open');
        },
        validateFieldEvent(event) {
            const field = event.target;
            this.validateField(field);
        },
        handleCustomSelectClick(event) {
            const select = event.target.closest('.custom-select');
            if (select.classList.contains('focus')) {
                this.customSelectToggl(event);
            }
        },
        handleCustomSelectFocus(event) {
            const select = event.target.closest('.custom-select');
            setTimeout(() => {
                select.classList.add('focus');
            }, 150);
            this.customSelectToggl(event);
        },
        handleCustomSelectBlur(event) {
            const select = event.target.closest('.custom-select');
            select.classList.remove('focus');
            const input = select.closest('.form-group')?.querySelector('input');
            if (input) {
                this.validateField(input);
            }
        },
        handleCustomOptionSelect(event) {
            const option = event.target;
            const select = option.closest('.custom-select');
            const trigger = select.querySelector('.custom-select-trigger span');
            const hiddenInput = select.parentElement?.querySelector('input[type="hidden"]');
            if (select.classList.contains('focus')) {
                select.querySelectorAll('.custom-option').forEach((o) => o.classList.remove('selected'));
                option.classList.add('selected');
                trigger.textContent = option.textContent;
                hiddenInput.value = option.getAttribute('data-value') || '';
                select.classList.remove('open');
            }
            const input = select.closest('.form-group')?.querySelector('input');
            if (input) {
                this.validateField(input);
            }
        },
        adjustTextareaHeightEvent() {
            const textareas = document.querySelectorAll('textarea');
            textareas.forEach((textarea) => this.adjustTextareaHeight(textarea));
        },
        handleFileSelection(event) {
            const input = event.target;
            const fileListContainer = document.getElementById('fileList');
            fileListContainer.innerHTML = '';
            if (input.files) {
                if (input.files.length > 0) {
                    const files = Array.from(input.files);
                    files.forEach((file) => {
                        const fileItem = document.createElement('div');
                        fileItem.classList.add('file-list-item');
                        fileItem.textContent = file.name;
                        fileListContainer.appendChild(fileItem);
                    });
                }
            }
        },
    },
    events: [
        ['click', '.contact-form a[href^="/"]:not([target])', function (event) {
                event.preventDefault();
                const href = event.target.closest('a')?.getAttribute('href') || '';
                console.log('Navigiere zu:', href);
                router.navigate(href);
            }],
        ['submit', '#contactForm', async function (event) {
                event.preventDefault();
                const form = event.target;
                const formData = new FormData(form);
                const jsonData = Object.fromEntries(formData.entries());
                await this.submitForm(event);
            }],
        ['blur', 'input, textarea', function (event) { this.validateFieldEvent(event); }],
        ['input', 'input, textarea', function (event) { this.validateFieldEvent(event); }],
        ['mousedown', 'label[for]', function (event) {
                event.preventDefault();
                const group = event.target.closest('.form-group');
                if (!group)
                    return;
                const isGroupLabel = group.tagName === 'LABEL';
                const label = isGroupLabel ? group : group.querySelector('label');
                const newActiveElement = group.querySelector(\`[name="$-{label?.getAttribute('for')}"], [name]\`);
                if (newActiveElement && newActiveElement !== document.activeElement) {
                    document.activeElement?.blur();
                    newActiveElement.focus();
                }
            }],
        ['mousedown', 'label input, label textarea', function (event) {
                event.stopPropagation();
            }],
        ['mousedown', 'label[for]', function (event) {
                event.preventDefault();
                const group = event.target.closest('.form-group');
                if (!group)
                    return;
                const isGroupLabel = group.tagName === 'LABEL';
                const label = isGroupLabel ? group : group.querySelector('label');
                const newActiveElement = group.querySelector(\`[name="$-{label?.getAttribute('for')}"], [name]\`);
                if (newActiveElement && newActiveElement !== document.activeElement) {
                    document.activeElement?.blur();
                    newActiveElement.focus();
                }
            }],
        ['mousedown', 'label input, label textarea', function (event) {
                event.stopPropagation();
            }],
        ['click', '.custom-select-trigger', function (event) { this.handleCustomSelectClick(event); }],
        ['focus', '.custom-select', function (event) { this.handleCustomSelectFocus(event); }],
        ['blur', '.custom-select', function (event) { this.handleCustomSelectBlur(event); }],
        ['click', '.custom-option', function (event) { this.handleCustomOptionSelect(event); }],
        ['click', window, function (event) {
                document.querySelectorAll('.custom-select.open').forEach((select) => {
                    if (!select.contains(event.target)) {
                        select.classList.remove('open');
                    }
                });
            }],
        ['input', 'textarea', function (event) { this.adjustTextareaHeightEvent(event); }],
        ['resize', window, function (event) { this.adjustTextareaHeightEvent(event); }],
        ['change', '#attachment', function (event) { this.handleFileSelection(event); }],
        ['click', '#fileList', function (event) {
            }],
        ['click', '.form-group.attachment .label', function (event) {
                event.target.closest('.form-group').querySelector('input[type="file"]').click();
            }],
        ['click', '.form-group.attachment .filelist-delete', function (event) {
                const input = event.target.closest('.form-group').querySelector('input[type="file"]');
                input.value = '';
                this.handleFileSelection({ target: input });
            }],
        ['input', 'input, textarea', function (event) {
                const field = event.target;
                field.classList.toggle('has-value', field.value.trim().length > 0);
            }],
    ],
    async mounted() {
        try {
            const response = await fetch("https://fase2.de/server/get-csrf-token.php", {
                method: "GET",
                credentials: "include",
            });
            if (!response.ok)
                throw new Error("CSRF-Token konnte nicht abgerufen werden.");
            const data = await response.json();
        }
        catch (error) {
            console.error("❌ Fehler beim Abrufen des CSRF-Tokens:", error);
        }
        document.querySelectorAll('input, textarea').forEach((field) => {
            field.classList.toggle('has-value', field.value.trim().length > 0);
        });
    },
};
 })()`
    };
  